import React from "react"
import PropTypes from "prop-types"
import Tag from "../tag"
import * as Icon from "react-feather"

import programParser from "../../helpers/programs"
import eventParser from "../../helpers/eventTypes"
import countryParser from "../../helpers/countries"

const EventCard = ({
  name,
  description,
  day,
  month,
  location,
  type,
  programs,
}) => (
  <div className="event-card card">
    <div className="event-card__top">
      <div className="event-card__top-left">
        <div className="event-card__date">
          <p>{day}</p>
          <p>{month}</p>
        </div>
        <div className="event-card__info">
          <p className="event-card__name">{name}</p>
          <p className="event-card__location">
            {`${countryParser[location] || location}, ${
              eventParser[type] || type
            }`}
          </p>
        </div>
      </div>
      <div className="event-card__cta">
        <Icon.ArrowRight className="icon icon--sm" />
      </div>
    </div>

    {description && (
      <div className="event-card__middle">
        <p>{description}</p>
      </div>
    )}
    <div className="event-card__bottom">
      {programs &&
        programs.map((p) => (
          <div key={p} className="event-card__bottom-slot">
            <Tag label={programParser[p] || p} />
          </div>
        ))}
      {programs && programs.length === 0 && (
        <div className="event-card__bottom-slot">
          <Tag label="none" />
        </div>
      )}
    </div>
  </div>
)

EventCard.defaultProps = {
  name: "",
  description: "",
  day: "",
  month: "",
  year: "",
  location: "",
  type: "",
  programs: [],
}

EventCard.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  day: PropTypes.number,
  month: PropTypes.string,
  year: PropTypes.number,
  location: PropTypes.string,
  type: PropTypes.string,
  programs: PropTypes.arrayOf(PropTypes.string),
}

export default EventCard
